@if (scrollState.hasScrollBar) { @if (!scrollState.scrolledToLeft) {
<div
  class="control left d-sm-flex d-none justify-content-center"
  (click)="scrollLeft()"
>
  <fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
</div>
} @if (!scrollState.scrolledToRight && !scrollState.showHasMore) {
<div
  class="control right d-sm-flex d-none justify-content-center"
  (click)="scrollRight()"
>
  <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
</div>
} @if (scrollState.showHasMore) {
<div
  class="control more right d-flex justify-content-center align-items-center"
  (click)="scrollRight()"
>
  <ng-container i18n="@@moreShopsLabel"> More shops </ng-container>
  <fa-icon class="pl-1" [icon]="['fas', 'arrow-right']"></fa-icon>
</div>
} }
